import React, { ReactNode } from 'react';

import BlurPopup from 'components/BlurPopup';
import FormBody from 'components/FormBody';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import styles from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/AgreementPopup/AgreementPopup.module.scss';

interface AgreementPopupProps {
  isModalOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const AgreementPopup = ({ isModalOpen, onClose, children }: AgreementPopupProps) => {
  return (
    <>
      <BlurPopup
        id="popup"
        classes={{
          paper: styles.paper,
          container: styles.container,
        }}
        onClose={onClose}
        open={isModalOpen}
        scroll="body"
        blurDeep={2}
      >
        <FormBody formBodyClassName={styles.form}>
          <div className={styles.content}>{children}</div>
          <div className={styles.buttonsContainer}>
            <Button className={styles.backButton} buttonType={ButtonType.Secondary} withArrow onClick={onClose}>
              Back
            </Button>
          </div>
        </FormBody>
      </BlurPopup>
    </>
  );
};

export default AgreementPopup;
